import React, { useEffect } from 'react';

const Confetti = ({ show }) => {
  useEffect(() => {
    if (!show) return;

    const createConfetti = (count = 30) => {
      for (let i = 0; i < count; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.background = Math.random() > 0.5 ? 'var(--primary)' : 'var(--accent)';
        confetti.style.animationDelay = Math.random() * 0.2 + 's';
        document.body.appendChild(confetti);
        
        setTimeout(() => {
          if (confetti.parentNode) {
            confetti.parentNode.removeChild(confetti);
          }
        }, 1200);
      }
    };

    createConfetti();
  }, [show]);

  return null;
};

export default Confetti;